<template>
    <a-modal title="批量修改项目明细" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel"
        destroyOnClose :maskClosable="false">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="已勾选数据">
                {{ form.ids.length }}条
            </a-form-model-item>
            <a-form-model-item label="修改类型" prop="type" required>
                <a-radio-group v-model="form.type">
                    <a-radio value="1">预订单</a-radio>
                    <a-radio value="2">供应商结算</a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="修改结果" prop="typemodel1" required>
                <a-radio-group v-model="form.typemodel1" v-if="form.type == '1'">
                    <a-radio value="1">已发预订单</a-radio>
                    <a-radio value="2" style="color: red">未发预订单</a-radio>
                </a-radio-group>
                <a-radio-group v-model="form.typemodel2" v-if="form.type == '2'">
                    <a-radio value="1">已给供应商结算</a-radio>
                    <a-radio value="2" style="color: red">未给供应商结算</a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            fileList: [],
            form: {
                ids: [],
                type: "1",//1是发预订单2供应商结算
                typemodel1: "1",//1是2否
                typemodel2: "1",//1是2否
            },
            groupList: [],
            loadingGroup: false,
            rules: {

            },
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
    },
    methods: {
        init(ids) {
            this.visible = true;
            this.form.ids = ids;
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(this.form);
                    this.confirmLoading = true;
                    this.$http({
                        url: '/admin/finance/batchUpdateProject',
                        method: "post",
                        data: this.form,
                    })
                        .then(() => {
                            this.$message.success('修改成功');
                            this.handleCancel();
                            this.$emit("ok");
                        })
                        .catch(() => {
                            this.confirmLoading = false;
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleCancel() {
            this.visible = false;
            this.confirmLoading = false;
            this.$refs["ruleForm"].resetFields();
            this.fileList = [];
        },
    },
};
</script>

<style></style>